import { ApiClient } from './api-client';
import { ConfigState } from 'store/config/types';

interface ApiClientState {
  config: ConfigState;
}

export const apiClient = (
  state: ApiClientState,
  baseUrlOverride?: string | null,
  authTokenOverride?: string | null,
): ApiClient => {
  const baseUrl = baseUrlOverride ?? state.config.apiUrl;
  const authToken = authTokenOverride ?? state.config.authToken;

  return new ApiClient(baseUrl, authToken);
};
